import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './AuthContext';

/**
 * AuthGuard component for route protection
 * 
 * Reads authentication state from useAuth hook and:
 * - Renders <Outlet /> when authenticated (allows access to protected routes)
 * - Renders <Navigate to="/login" replace /> when unauthenticated (redirects to login)
 * 
 * Requirements: 2.1, 2.3
 */
export const AuthGuard: React.FC = () => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};
